import { CartAddEvent } from '@theme/events';
import { fetchConfig } from '@theme/utilities';

class CartDrawerUpsell extends HTMLElement {
  connectedCallback() {
    this.button = this.querySelector('[data-upsell-add]');
    this.buttonText = this.querySelector('[data-add-text]');
    this.price = this.querySelector('[data-upsell-price]');
    this.variantSelect = this.querySelector('[data-variant-select]');
    this.variantInput = this.querySelector('[data-variant-id]');
    this.defaultButtonText = this.buttonText?.textContent?.trim() || 'Add';

    this.button?.addEventListener('click', this.handleAdd);
    this.variantSelect?.addEventListener('change', this.handleVariantChange);
  }

  disconnectedCallback() {
    this.button?.removeEventListener('click', this.handleAdd);
    this.variantSelect?.removeEventListener('change', this.handleVariantChange);
  }

  handleVariantChange = () => {
    const option = this.variantSelect?.selectedOptions?.[0];

    if (this.price && option?.dataset.price) {
      this.price.textContent = option.dataset.price;
    }

    if (this.button) {
      this.button.disabled = option?.disabled || false;
    }
  };

  handleAdd = (event) => {
    event.preventDefault();

    if (!this.button || this.button.disabled) return;

    const variantId = this.variantSelect?.value || this.variantInput?.value;
    if (!variantId) return;

    this.setLoading(true);

    const cartItemsComponents = document.querySelectorAll('cart-items-component');
    const sectionIds = [];
    cartItemsComponents.forEach((item) => {
      if (item instanceof HTMLElement && item.dataset.sectionId) {
        sectionIds.push(item.dataset.sectionId);
      }
    });

    const formData = new FormData();
    formData.set('id', variantId);
    formData.set('quantity', '1');
    formData.set('sections', [...new Set(sectionIds)].join(','));
    formData.set('sections_url', window.location.pathname);

    const config = fetchConfig('javascript', { body: formData });

    fetch(Theme.routes.cart_add_url, {
      ...config,
      headers: {
        ...config.headers,
        Accept: 'text/html',
      },
    })
      .then((response) => response.json())
      .then((response) => {
        if (response.status) throw new Error(response.message || 'Unable to add item');

        this.dispatchEvent(
          new CartAddEvent({}, variantId.toString(), {
            source: 'cart-drawer-upsell',
            itemCount: 1,
            productId: this.dataset.productId,
            variantId: variantId.toString(),
            sections: response.sections,
          })
        );

        this.setAdded();
      })
      .catch((error) => {
        console.error(error);
        this.setLoading(false);
      });
  };

  setLoading(isLoading) {
    if (!this.button || !this.buttonText) return;

    this.button.disabled = isLoading;
    this.buttonText.textContent = isLoading ? 'Adding...' : this.defaultButtonText;
  }

  setAdded() {
    if (!this.button || !this.buttonText) return;

    this.button.disabled = true;
    this.buttonText.textContent = 'Added';
  }
}

if (!customElements.get('cart-drawer-upsell')) {
  customElements.define('cart-drawer-upsell', CartDrawerUpsell);
}
